import {Logger, Category} from '@simpleinvest/front-end-logger';

const logger = new Logger({
  category: Category.RwSdkJs,
  fileName: 'sdk/index.js',
});

export const apiKey = process.env.VUE_APP_MS_API_GATEWAY_KEY;

export const endpoint = process.env.VUE_APP_MICROSERVICES_API_GATEWAY_ENDPOINT;
interface ClientLogger {
  error: (error: Error) => void;
  warn: (message: string) => void;
  info: (message: string) => void;
  http: (message: string) => void;
  verbose: (message: string) => void;
  debug: (message: string) => void;
  silly: (message: string) => void;
}

export const getLogger = (): ClientLogger => ({
  error: (error): void =>
    logger.addBreadcrumb({
      message: `Error Name: ${error.name} Error Message: ${error.message} Error stack: ${error.stack}`,
      level: 'error',
    }),
  warn: (message): void => logger.addBreadcrumb({message, level: 'warning'}),
  info: (message): void => logger.addBreadcrumb({message, level: 'info'}),
  http: (message): void => logger.addBreadcrumb({message}),
  verbose: (message): void => logger.addBreadcrumb({message, level: 'debug'}),
  debug: (message): void => logger.addBreadcrumb({message, level: 'debug'}),
  silly: (message): void => logger.addBreadcrumb({message, level: 'log'}),
});
